import type { FaireProductEntity } from "../../entity_types/product";

export const p_dewo7qm88x: FaireProductEntity = {
  token: "p_dewo7qm88x",
  type: "product",
  name: "Helium 50 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d5d36230c35bb081ec12bfeea74ccd026cab0e3752ef94f6f5abbc1bc52412dd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/177d4b9f27fb9f8978ea56451eeb1a37fe39fe3bda73e5b6fda1b1c82b24cf23.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:12.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
